<div class="orgApp-duty-table-container orgApp-duties-table-div">
  <table mat-table [dataSource]="dataSource" class="orgApp-duties-main-table">
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="orgApp-sticky-header orgApp-header-row-border"
      >
        {{ "duties.content.name" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{ disableTableRow: !element.active }"
      >
        {{ element.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="orgApp-sticky-header orgApp-header-row-border"
      >
        {{ "duties.content.description" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{ disableTableRow: !element.active }"
      >
        {{ element.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dutyDuration">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="orgApp-sticky-header orgApp-header-row-border"
      >
        {{ "duties.content.duty_duration" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{ disableTableRow: !element.active }"
      >
        {{ element.firstSlotStartTime }} -
        {{ element.firstSlotEndTime }}
      </td>
    </ng-container>

    <ng-container matColumnDef="breakDuration">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="orgApp-sticky-header orgApp-header-row-border"
      >
        {{ "duties.content.break" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [ngClass]="{ disableTableRow: !element.active }"
      >
        {{ element.breakHours }}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="orgApp-sticky-header orgApp-header-row-border"
      >
        {{ "duties.content.active" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        (click)="handleCellClick($event, 'active')"
        [ngClass]="{ disableTableRow: !element.active }"
      >
        <mat-slide-toggle
          class="orgApp-toggle-color"
          [checked]="element.active === true"
          (change)="onToggleChange($event.checked, element.dutyDepartmentId)"
          (click)="$event.stopPropagation()"
        ></mat-slide-toggle>
      </td>
    </ng-container>
    <ng-container matColumnDef="more">
      <th
        mat-header-cell
        class="orgApp-header-row orgApp-sticky-header orgApp-header-row-border orgApp-table-action-col"
        *matHeaderCellDef
        aria-label="row actions"
      >
        &nbsp;
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <button
          type="button"
          mat-icon-button
          class="float-right"
          (click)="editDuty(element); $event.stopPropagation()"
        >
        <svg width="20" height="20">
          <use xlink:href="#edit-icon-grey" x="4" y="4"></use>
        </svg>
        </button>
      </td>
    </ng-container>

    <tr
      mat-header-row
      class="orgApp-header-row orgApp-sticky-header orgApp-header-row-border"
      *matHeaderRowDef="columnsToDisplayWithExpand; sticky: true"
    ></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplayWithExpand"
      class="main-table-row"
      (click)="editDuty(element)"
    ></tr>
  </table>
</div>
<app-table-pagination
  [totalRecords]="totalRecords"
  [pageSize]="pageSize"
  (onPaginateChange)="onPaginateChange($event)"
></app-table-pagination>
